import React from 'react';
import { Col, Row, Card, CardHeader, CardBody } from 'reactstrap';

export default function VisionandMission() {
    const gradientStyle = {
        backgroundColor: "#77236b",
        color: "white"
    };

    return (
        <div className="container mt-4 mb-4">
            <Row className="justify-content-center">
                <Col md={10}>
                    {/* Header Box */}
                    <div className="d-flex justify-content-center mb-5">
                        <div
                            style={{
                                backgroundColor: "#77236b",
                                padding: "12px 40px",
                                borderRadius: "8px",
                                border: "1px solid #cdd6f3",
                                boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                                color: "#fff",
                                textAlign: "center",
                                width: "100%",

                            }}
                        >
                            <h4 className="fw-bold m-0">विश्वविद्यालय दृष्टि, ध्येय एवं उद्देश्य</h4>
                        </div>
                    </div>

                    {/* Vision Section */}
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="text-center" style={gradientStyle}>
                            <h5 className="fw-bold m-0">दृष्टि (Vision)</h5>
                        </CardHeader>
                        <CardBody className="p-4">
                            <p style={{ textAlign: "justify", marginBottom: "0" }}>
                                वैश्विक परिप्रेक्ष्य में संस्कृत शिक्षा की गरिमा की संस्थापना के लिए महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, मौनधारा (मून्दडी), कपिष्ठलम् (कैथल) का विश्वस्तरीय विश्वविद्यालय के रूप में विकास।
                            </p>
                        </CardBody>
                    </Card>

                    {/* Mission Section */}
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="text-center" style={gradientStyle}>
                            <h5 className="fw-bold m-0">ध्येय (Mission)</h5>
                        </CardHeader>
                        <CardBody className="p-4">
                            <ul style={{ textAlign: "justify", listStyleType: 'disc', paddingLeft: '20px' }}>
                                <li>संस्कृत विद्या की समग्र शाखाओं का सर्वाङ्गीण विकास तथा आधुनिक प्रणालियों के द्वारा संस्कृत साधनों की उपलब्धि।</li>
                                <li>संस्कृत, पालि, प्राकृत एवं अन्य भारतीय भाषाओं में परस्पर सांस्कृतिक अन्त: सम्बन्धों के परिप्रेक्ष्य में शिक्षण व अनुसन्धान की व्यवस्था करते हुए भाषिक विविधता तथा सांस्कृतिक बहुलता का उन्नयन करना।</li>
                                <li>संस्कृत के साथ-साथ अन्य भारतीय भाषाओं की ज्ञान प्रणालियों में दार्शनिक एवं वैज्ञानिक तत्त्वों का संरक्षण एवं समुन्नयन तथा इन भारतीय ज्ञान-परम्पराओं का सांस्कृतिक धरोहर के साथ सम्बन्ध स्थापित करते हुए सूचना और संचार प्रौद्योगिकी के माध्यम से इनकी उपलब्धता सुनिश्चित करना।</li>
                            </ul>
                        </CardBody>
                    </Card>

                    {/* Objectives Section */}
                    <Card className="mb-4 shadow-sm">
                        <CardHeader className="text-center" style={gradientStyle}>
                            <h5 className="fw-bold m-0">उद्देश्य (Objectives)</h5>
                        </CardHeader>
                        <CardBody className="p-4">
                            <p style={{ textAlign: "justify", marginBottom: "1rem" }}>
                                संस्कृत विश्वविद्यालय की स्थापना का उद्देश्य संस्कृत विद्या का आधुनिक दृष्टिकोण से प्रचार-प्रसार, संरक्षण एवं प्रोत्साहन तथा निम्नलिखित उद्देश्यों का भी पालन करना :-
                            </p>
                            <ul style={{ textAlign: "justify", listStyleType: 'disc', paddingLeft: '20px' }}>
                                <li>संस्कृत विद्या की सभी विधाओं में अनुसन्धान, प्रोत्साहन तथा संयोजन करना है, साथ ही शिक्षक-प्रशिक्षण तथा पाण्डुलिपि विज्ञान आदि को भी संरक्षण देना, जिससे पाठमूलक प्रासंगिक विषयों में आधुनिक शोध के निष्कर्ष के साथ सम्बन्ध स्पष्ट किया जा सके तथा इनका प्रकाशन हो सके।</li>
                                <li>विशेषतः हरियाणा के समान उद्देश्यों वाली अन्य संस्थाओं को विश्वविद्यालय से सम्बद्ध करना।</li>
                                <li>संस्कृत संवर्धन के लिए हरियाणा राज्य सरकार की नीतियों एवं योजनाओं को लागू करना।</li>
                                <li>शोध एवं ज्ञान के प्रचार-प्रसार एवं विकास के लिए समुचित व्यवस्थाओं को उपलब्ध करना।</li>
                                <li>प्राचीन-अर्वाचीन अध्ययन एवं विस्तारित योजनाएँ जो समाज के विकास में योगदान देती हों, उनका उत्तरदायित्व लेना।</li>
                                <li>पालि, प्राकृत एवं अन्य भारतीय भाषाओं का संरक्षण एवं संवर्धन करना।</li>
                                <li>प्राच्य विद्याओं की दुर्लभ पाण्डुलिपियों एवं पुस्तकों का प्रकाशन करना।</li>
                                <li>भारतीय ज्ञान-परम्परा में शोध एवं प्रशिक्षण का कार्य करना।</li>
                                <li>उपरोक्त के अतिरिक्त उन सभी उत्तरदायित्वों एवं कार्यों का निष्पादन करना जो इस संस्कृत विश्वविद्यालय के उद्देश्यों को बढ़ाने के लिए आवश्यक हो।</li>
                            </ul>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}
